<template>
  <div class="container" v-if="!isFetchingNews">
    <AppBar class="details" :class="{ 'side-panel': contentPanel }">
      <template v-if="storyMode === storyModes.CREATION" v-slot:title>
        Nova Retranca
      </template>
      <template v-else v-slot:title>
        Detalhes da Pauta
      </template>

      <template v-slot:actions-right>
        <!-- TODO: corrigir problema para deletar uma STORY -->
        <!-- <v-btn
          :large="$vuetify.breakpoint.lgAndUp"
          icon
          class="link"
          title="Deletar pauta"
          @click.stop="deleteDialog = true"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn> -->
        <v-btn
          :large="$vuetify.breakpoint.lgAndUp"
          icon
          class="link"
          title="copiar texto"
          @click.stop="copy(selectedStory.data.body)"
        >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
        <v-btn
          :large="$vuetify.breakpoint.lgAndUp"
          icon
          @click.stop="
            copy(
              domain + $route.fullPath,
              'Link copiado para área de transferência!',
            )
          "
        >
          <v-icon>mdi-share-variant</v-icon>
        </v-btn>

        <v-btn
          v-if="$vuetify.breakpoint.mdAndDown"
          icon
          title="Conteúdo relacionado"
          @click="contentPanel = !contentPanel"
        >
          <v-icon>mdi-card-bulleted</v-icon>
        </v-btn>
      </template>
    </AppBar>

    <StoryDetail
      @showMessage="showSnackbarWithMessage"
      @copyError="onCopyError"
      @hideSnackbar="hideSnackbar"
      :isConflict="false"
      :conflictDetail="false"
      :selectedStory="selectedStory"
      :storyMode="storyMode"
      :class="{ 'side-panel': contentPanel }"
    />

    <div>
      <StoryDetailSidebar
        @logout="logout"
        @select-similar-story="setConflict"
        @launch-analytics="launchAnalytics"
        @load-more-stories="getNextConflicts(selectedStory)"
        :isLoadingRelatedVideos="isFetchingVideos"
        :isLoadingSimilarStories="isWaitingConflicts"
        :storyMode="storyMode"
        :relatedVideos="relatedVideos"
        :selectedStory="selectedStory"
        :similarStories="storyConflicts"
        :drawer="contentPanel"
        @changeContentPanel="changeContentPanel"
      />
    </div>

    <v-navigation-drawer
      class="panel detalhes-pauta"
      v-model="drawer"
      right
      floating
    >
      <div class="detalhes-pauta-wrapper" v-if="conflictedStory">
        <!-- Topo -->
        <div class="panel-header">
          <div class="header-slot left">
            <div class="title">
              Pauta Similar
            </div>
          </div>
          <div class="header-slot right">
            <v-btn icon @click.stop="drawer = !drawer">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <!-- Meio -->
        <div class="panel-content">
          <div class="content-title">
            {{ conflictedStory.data.title }}
          </div>

          <div class="content-text" v-html="conflictedStory.data.body"></div>
        </div>

        <div class="panel-footer">
          <div class="slot left">
            <div class="slot-item path">
              <v-icon left>folder_special</v-icon>
              <v-chip
                class="path"
                v-for="(tag, index) in tags"
                :key="index"
                outlined
                >{{ tag }}
              </v-chip>
            </div>

            <div class="slot-item">
              <v-chip outlined>
                <v-icon>date_range</v-icon>
                {{ conflictedDate }}
              </v-chip>
            </div>

            <div class="slot-item">
              <v-chip outlined class="name">
                <v-icon>person</v-icon>
                {{
                  conflictedStory.data.modified_by ||
                    conflictedStory.data.author
                }}
              </v-chip>
            </div>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- modal deletion -->
    <v-dialog v-model="deleteDialog" max-width="480">
      <div class="dialog-icon">
        <v-icon>mdi-alert-circle-outline</v-icon>
      </div>

      <div class="dialog-title">Deletar Retranca</div>
      <div class="dialog-description">
        <span>Tem certeza que deseja deletar essa retranca?</span> Essa operação
        é irreversível e também deletará a retranca no iNews.
      </div>

      <div class="dialog-actions">
        <v-btn color="secondary" large @click="deleteDialog = false"
          >Cancelar
        </v-btn>
        <v-btn color="primary" class="white--text" large @click="deleteStory()"
          >Sim, deletar retranca</v-btn
        >
      </div>
    </v-dialog>
    <!-- modal deletion:end -->
  </div>
</template>

<script>
import { timeFormat, dateFormat, toLocalTime } from '@/utils/date.js';
import { mapActions, mapState } from 'vuex';
import { copyToClipboard } from '@/utils/text.js';
import AppBar from '@/components/shared/AppBar.vue';
import StoryDetail from '@/components/stories/StoryDetail.vue';
import StoryDetailSidebar from '@/components/stories/StoryDetailSidebar.vue';
import { categories, actions } from '@/constants/analytics.js';
import { storyModes } from '@/utils/mappers.js';

export default {
  name: 'Story',
  components: {
    AppBar,
    StoryDetail,
    StoryDetailSidebar,
  },
  data() {
    return {
      contentPanel: this.getDrawerInitialCondition(),
      conflictedStory: null,
      storyModes,
      drawer: false,
      domain: window.location.origin,
      deleteDialog: false,
    };
  },
  computed: {
    ...mapState({
      selectedStory: state => state.news.selectedStory,
      storyConflicts: state => state.news.storyConflicts,
      snackbarBox: state => state.news.snackbarBox,
      isWaitingConflicts: state => state.news.isWaitingConflicts,
      isFetchingNews: state => state.news.isFetchingNews,
      storyMode: state => state.news.storyMode,
      relatedVideos: state => state.videos.relatedVideos,
      isFetchingVideos: state => state.videos.isFetchingVideos,
    }),
    conflictedDate() {
      return dateFormat(
        toLocalTime(this.conflictedStory.data.modified_date) ||
          toLocalTime(this.conflictedStory.data.creation_date),
      );
    },
    conflitedTime() {
      return timeFormat(
        toLocalTime(this.conflictedStory.data.modified_date) ||
          toLocalTime(this.conflictedStory.data.creation_date),
      );
    },
    tags() {
      return this.conflictedStory.data.path.split('.');
    },
  },
  created() {
    if (this.$route.params.story_id) {
      this.$store.dispatch('news/setStoryMode', storyModes.VIEW);
      this.$store.dispatch('news/selectStory', {
        story_id: this.$route.query.slug_id || this.$route.params.story_id,
        contact: this.$route.query.content === 'contact',
      });
    } else {
      this.$store.dispatch('news/setStoryMode', storyModes.CREATION);
      this.$store.dispatch('news/updateFieldMapping', {
        place: this.$route.params.place,
        folder: this.$route.params.folder,
        formatFields: false,
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('news/setStoryMode', storyModes.VIEW);

    if (from.path !== '/story-create') {
      this.$store.dispatch('news/unsetStoryConflicts');
      this.$store.dispatch('news/unsetStory');
    } else {
      this.$store.dispatch('news/resetFieldMapping');
    }

    this.$store.dispatch('videos/resetVideos');

    this.hideSnackbar();
    next();
  },
  methods: {
    ...mapActions('news', ['getNextConflicts']),
    copy(text, successMsg) {
      try {
        copyToClipboard(text);
        this.showSnackbarWithMessage(successMsg);
      } catch (error) {
        this.onCopyError();
      }
    },
    logout() {
      this.$store.dispatch('logout');
    },
    changeDrawer(drawer) {
      this.drawer = drawer;
    },
    changeContentPanel(drawer) {
      this.contentPanel = drawer;
    },
    setConflict(story) {
      this.conflictedStory = story;
      this.drawer = true;
      this.launchAnalytics({
        category: categories.storyConflicts,
        action: actions.showDetails,
        label: story.data.title,
      });
    },
    showSnackbarWithMessage(message) {
      this.$store.dispatch('news/updateFeedbackMessage', message);
      this.$store.dispatch('news/snackbarTrigger', true);
    },
    hideSnackbar() {
      this.$store.dispatch('news/snackbarTrigger', false);
    },
    onCopyError() {
      this.showSnackbarWithMessage('Erro ao copiar para área de transferência');
    },
    getDrawerInitialCondition() {
      return !!this.$vuetify.breakpoint.lgAndUp;
    },
    launchAnalytics({ category, action, label }) {
      this.$store.dispatch('analyticsEvent', { category, action, label });
    },
    handleClose() {
      this.conflictedStory = null;
      this.drawer = !this.drawer;
    },
    deleteStory() {
      this.launchAnalytics({
        category: categories.delete,
        action: actions.deleteClicked,
        label: this.storyTitle,
      });

      this.deleteDialog = false;
      this.$store.dispatch('news/deleteStory', this.selectedStory);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/navigationDrawer-v2.scss';

.v-navigation-drawer {
  &.detalhes-pauta {
    position: fixed;
    width: 400px !important;
    background-color: $color-white;
    overflow: hidden !important;

    @include for-size(phone-only) {
      width: 88% !important;
    }

    ::v-deep .v-navigation-drawer__content {
      overflow: hidden !important;

      .panel-content {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        align-content: flex-start;
        overflow: hidden !important;
        height: calc(100vh - 168px);

        .content-title,
        .content-text {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
        }
        .content-title {
          padding: 16px 0 24px 0;
          font-size: 1.2em;
          font-family: 'globotipo' !important;
          font-weight: 300 !important;
          line-height: 1.2em;
          border-bottom: solid 1px $color-black-08;
        }

        .content-text {
          align-items: flex-start;
          margin: 24px 0 0 0;
          padding: 0 16px 88px 0;
          font-size: 0.88em;
          line-height: 1.4em;
          height: 100%;
          overflow-y: auto !important;
        }
      }
    }

    .panel-footer {
      position: relative;
      display: flex;
      justify-content: flex-start;
      width: 100%;
      height: 80px;
      padding: 0;
      box-sizing: border-box;
      border-top: solid 1px $color-black-08;
      border-bottom: solid 16px $color-black-24;

      &::after {
        content: '';
        position: absolute;
        z-index: 9;
        bottom: -8px;
        left: 0;
        width: 100%;
        height: 8px;
        background-color: rgba($color-white, 0.4);
      }

      .slot {
        min-height: 100%;
        display: flex;
        margin-top: -8px;

        .slot-item {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          margin: 0 8px 0 0;
          padding: 0;

          .v-icon {
            font-size: 1.2em;
            margin: -2px 4px 0 0;
            color: $color-black-16;
          }

          .v-chip {
            display: flex;
            flex-wrap: wrap;
            font-family: 'globotipo' !important;
            font-weight: 500 !important;
            font-size: 0.8em;
            color: $color-black-40;
            text-transform: uppercase;
            border: none;
            margin: 0 !important;
            padding: 0 !important;

            &.path {
              &::after {
                content: '/';
                color: $color-black-24;
                margin: 0 2px;
              }
            }

            &.name {
              text-transform: lowercase;
            }
          }

          .v-btn {
            &.link {
              .v-icon {
                color: $color-black-80;
              }
            }
          }
        }

        &.left {
          flex: 1;
          justify-content: flex-start;
        }

        &.right {
          flex: 2;
          justify-content: flex-end;

          .slot-item {
            margin: 0 0 0 16px;
          }
        }
      }
    }
  }
}

// Dialogs
::v-deep.v-dialog__content {
  .v-dialog {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;
    background-color: $color-white !important;
    box-shadow: 0 8px 40px rgba($color-black, 0.24);

    @include for-size(phone-only) {
      padding: 24px;
    }

    .dialog-icon,
    .dialog-title,
    .dialog-description,
    .dialog-actions {
      display: flex;
    }

    .dialog-icon {
      margin: 0 0 24px 0;
      justify-content: center;

      .v-icon {
        font-size: 4em;
        color: $color-black-16;

        @include for-size(phone-only) {
          font-size: 3.2em;
        }
      }
    }

    .dialog-title,
    .dialog-description {
      justify-content: center;
      text-align: center;
    }

    .dialog-title {
      font-family: 'globotipo' !important;
      font-weight: 600 !important;
      font-size: 1.6em;
      font-style: italic;
      color: $color-black-80;

      @include for-size(phone-only) {
        font-size: 1.4em;
      }
    }

    .dialog-description {
      flex-direction: column;
      margin: 8px 0 0 0;
      padding: 0 40px;
      font-size: 0.88em;
      font-style: italic;
      line-height: 1.2em;
      color: $color-black-64;

      @include for-size(phone-only) {
        display: block;
        padding: 0 16px;
      }

      span {
        font-family: 'globotipo' !important;
        font-weight: 600 !important;

        @include for-size(phone-only) {
          font-family: 'globotipo' !important;
          font-weight: 400 !important;
        }
      }
    }

    .dialog-actions {
      margin: 40px 0 0 0;
      justify-content: flex-end;

      .v-btn {
        margin: 0 0 0 8px;
      }
    }
  }
}
</style>
